import React from 'react';

const Select = ({ 
  label,
  error,
  className = '',
  size = 'md',
  children,
  ...props 
}) => {
  const sizes = {
    sm: 'px-3 py-2 text-sm rounded-lg',
    md: 'px-4 py-2.5 text-sm rounded-lg',
    lg: 'px-6 py-3 text-base rounded-lg'
  };
  
  const baseClasses = `w-full bg-gray-800 border border-gray-600 text-white focus:outline-none focus:ring-2 focus:ring-[#a15507]/50 focus:border-[#a15507] transition-colors ${sizes[size]} ${className}`;
  
  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-gray-300 mb-2">
          {label}
        </label>
      )}
      <select
        className={baseClasses}
        {...props}
      >
        {children}
      </select>
      {error && (
        <p className="mt-1 text-sm text-red-400">{error}</p>
      )}
    </div>
  );
};

export default Select;
